import React from 'react';

import { DropdownItem } from 'reactstrap';

import socialHttp from '../../../../../vendor/z5internet/react-social/src/resources/assets/js/src/utils/socialHttp';

import isUpgraded from '../../../js/components/upgrade/pay/isUpgraded';

const r = React;

const user = window.reduxStore.getState().user;

const feedActions = (p) => {
	const out = {};

	const pid = p.id.split('-');

	const user = window.reduxStore.getState().user;

	if (pid[3]) {
		return {};
	}

	if (!pid[3]) {
		// this is a post not a comment

		if (pid[1] == 'g') {
			const rootObj = p.id.split('-')[0] + '-' + p.id.split('-')[1];

			const feed = window.reduxStore.getState().feed[rootObj];

			const admin = parseFloat(feed.role) == 255;

			if (admin) {
				out[9999] = pinnedPost(p);
			}
		} else if (pid[1] == 'u' && isUpgraded() > 0 && pid[0] == user.id) {
			out[9999] = pinnedPost(p);
		}
	}

	return out;
};

export default feedActions;

function pinnedPost(post) {
	return [
		<DropdownItem key={'m-pre-k0'} header>
			Pin Post
		</DropdownItem>,
		<DropdownItem key={'m-pre-k1'} onClick={() => pin_post(post)}>
			Pin this post
		</DropdownItem>,
	];
}

function pin_post(post) {
	socialHttp(
		'post',
		'/data/feed/pinned_post/' +
			post.id.split('-').slice(0, 2).join('-') +
			'/' +
			post.id
	);
}
